export const dateKeysFormatDto = 'YYYY-MM-DD' as const

export type ProductDataDto = Array<{
  title: string
  items: Array<{
    title: string
    data_by_date: Record<string, { count: number; sum: number }>
    total: {
      count: number
      sum: number
    }
  }>
}>

export type ProductDataTotalDto = {
  data_by_date: Record<string, { count: number; sum: number }>
  total: {
    count: number
    sum: number
  }
}

export type PaymentMethodsDto = Record<
  'bank_card' | 'sbp' | 'cash' | 'internal',
  {
    data_by_date: Record<string, { count: number; sum: number }>
    total: {
      count: number
      sum: number
    }
  }
>
